import { render, staticRenderFns } from "./ImpactInitiative.vue?vue&type=template&id=eebe81f0&"
import script from "./ImpactInitiative.vue?vue&type=script&lang=js&"
export * from "./ImpactInitiative.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports